import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type SandClockFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const SandClockFilled = forwardRef<SVGSVGElement, SandClockFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-7.714465 -7.714408) scale(1.642881)">
        <path fillRule="evenodd" clipRule="evenodd" d="M16.9152 17.7703H17.7673C18.1073 17.7703 18.3813 18.0458 18.3813 18.3858C18.3813 18.7257 18.1058 18.9998 17.7673 18.9998H6.23109C5.89113 18.9998 5.61707 18.7242 5.61707 18.3858C5.61707 18.0458 5.89263 17.7718 6.23109 17.7718H7.03232V16.1888C7.03232 16.1618 7.03532 16.1348 7.03831 16.1079C7.10571 14.3976 9.09156 12.912 10.4679 12.0778C9.08856 11.2421 7.10271 9.75197 7.03681 8.03868C7.03382 8.01622 7.03232 7.99375 7.03232 7.96979V6.22805H6.23109C5.89113 6.22805 5.61707 5.95249 5.61707 5.61403C5.61707 5.27407 5.89263 5 6.23109 5H17.7688C18.1088 5 18.3828 5.27556 18.3828 5.61403C18.3828 5.95399 18.1073 6.22805 17.7688 6.22805H16.9167V7.96979C16.9167 7.99375 16.9152 8.01622 16.9122 8.03868C16.8463 9.75197 15.0102 11.2421 13.6309 12.0763C15.0192 12.9164 16.8582 14.4186 16.9122 16.1453C16.9137 16.1603 16.9137 16.1738 16.9137 16.1888V16.1962C16.9152 16.2322 16.9152 16.2696 16.9152 16.3071V16.3595V17.7703ZM14.2981 17.9903C14.558 17.9903 14.7675 17.7796 14.7675 17.5208C14.7675 17.262 14.5568 17.0525 14.2981 17.0513H9.70184C9.44191 17.0513 9.23237 17.262 9.23237 17.5208C9.23237 17.7807 9.44306 17.9903 9.70184 17.9903H14.2981ZM12.4694 11.7793C12.4694 11.5194 12.2587 11.3098 11.9999 11.3098C11.7412 11.3098 11.5316 11.5194 11.5305 11.7781V12.6953C11.5305 12.9552 11.7412 13.1648 11.9999 13.1648C12.2599 13.1648 12.4694 12.9541 12.4694 12.6953V11.7793ZM12.4694 9.7411C12.4694 9.48118 12.2587 9.27163 11.9999 9.27163C11.7412 9.27163 11.5316 9.48118 11.5305 9.7411C11.5305 10.001 11.7412 10.2106 11.9999 10.2106C12.2599 10.2106 12.4694 9.99988 12.4694 9.7411Z" fill={color} />
      </g>
    </svg>
  ),
);

SandClockFilled.displayName = 'SandClockFilled';

export default SandClockFilled;
